import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { AccordionActions } from "@material-ui/core";
import { Divider } from "@material-ui/core";
//import clsx from "clsx";
import { FormControl } from "@material-ui/core";
import ApproachCheckbox from "../ScreenComponents/ApproachCheckbox.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Card } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Content from "../ScreenComponents/Content";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";

/*
const useStyles = (theme) => ({
  root: {
    position: "relative",
    height: "auto",
    padding: "2rem",
    flexgrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    Items: "center",
  },
  column: {
    flexBasis: "100%",
  },
  helper: {
    //: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  //
  cardstyle: {
    padding: 10,
    backgroundColor: theme.palette.primary[900],
    color: "white",
  },
  cardstyle2: {
    padding: 10,
    backgroundColor: theme.palette.secondary[600],
    color: "white",
  },
});
*/
const useStyles = makeStyles((theme) => ({
  toolbar: {
    //paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "centers",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appToolbar: {
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      width: "100%",
      //marginLeft: "15%",
      //width: `calc(100% - ${DrawerWidth}px)`,
      //marginLeft: DrawerWidth,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  tacticContainer: {
    justifyContent: "center",
    alignItems: "center",
    direction: "row",
    spacing: 2,
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    //width: "100%",
  },
  fixedHeight: {
    height: 300,
  },
  balanceCard: {
    height: 400,
    //width: "100%",
    //width: 500,
  },
  cardstyle: {
    padding: 10,
    backgroundColor: theme.palette.primary[900],
    color: "white",
  },
  cardstyle2: {
    padding: 10,
    backgroundColor: theme.palette.secondary[600],
    color: "white",
  },
  details: {
    Items: "center",
  },
  column: {
    flexBasis: "100%",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export function Tailoring(props) {
  const classes = useStyles();
  //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  //const balancePaper = clsx(classes.paper, classes.balanceCard);
  const [value, setValue] = React.useState(0);
  let tailoringDict = props.currentContext.getTailoringChoice();
  //
  //let tailoringOptions = Object.keys(tailoringDict);

  // Statutory
  let statutoryDict = tailoringDict["Statutory"];
  let statutoryOptions = Object.keys(statutoryDict);
  // Statutory with Exceptions
  let exceptionDict = tailoringDict["Exception"];
  let exceptionOptions = Object.keys(exceptionDict);
  // Regulatory
  let regulatoryDict = tailoringDict["Regulatory"];
  let regulatoryOptions = Object.keys(regulatoryDict);

  const setChoice = (val, approach, group) => {
    props.currentContext.setTailoring(val.target.checked, approach, group);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const nextPage = (e) => {
    e.preventDefault();
    // PROCESS FORM //
    props.nextStep();
  };

  const prevPage = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  return (
    <>
      <Grid
        container
        xs={12}
        direction="row"
        spacing={2}
        className={classes.root}
      >
        <Grid
          container
          item
          direction="row"
          xs={6}
          style={{
            //backgroundColor: "#77a258",
            //padding: "15px",
            //color: "white",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Card className={classes.cardstyle2}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Typography>
                In preparing for your acquisition strategy, you have multiple
                tailoring options:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <List dense style={{ justifyContent: "center" }}>
                <ListItem>
                  <ListItemText
                    primary="Tailor Program Strategies - modify your
            approach based on the commodity, the risk, the criticality, the size
            and the complexity of the effort."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Tailor Program Oversight -
            request delegation as appropriate to maintain oversight at the
            appropriate level."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Tailor Decision Reviews - structure key
            decision points based on the timing of key planned events."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="
            Tailor
            Documentation - simplify or combine the required documentation as
            needed to meet intent while minimizing execution delays."
                  />
                </ListItem>
              </List>
            </Grid>
          </Card>
        </Grid>

        <Grid
          item
          container
          direciton="column"
          xs={6}
          style={{
            //backgroundColor: "#77a258",
            //padding: "15px",
            //color: "white",
            alignItems: "stretch",
            justifyContent: "center",
          }}
        >
          <Card className={classes.cardstyle}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Typography>Actions On Your End:</Typography>
            </Grid>
            <Grid item xs={12}>
              <List dense style={{ justifyContent: "center" }}>
                <ListItem>
                  <ListItemText primary="Discuss tailoring options with your acquisition executive." />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Identify forward thinkers from each functional and stakeholder organizations to collaborate with on the appropriate tailoring in advance of any decisions." />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Borrow lessons learned from other programs." />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="
                    Don't be afraid to ask - you can only be told no.."
                  />
                </ListItem>
              </List>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <Content>
        <Paper>
          <AppBar
            color="secondary"
            position="static"
            className={classes.appToolbar}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs"
            >
              <Tab label="Statutory" />
              <Tab label="Statutory with Exceptions" />
              <Tab label="Regulatory" />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <Grid item container xs={12}>
              {statutoryOptions.map((elem) => (
                <Accordion
                  key={statutoryOptions.indexOf(elem)}
                  style={{ width: "100%" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <FormControl style={{ marginRight: 16 }}>
                      <ApproachCheckbox
                        checkedVal={
                          props.currentContext.tailoringChoice["Statutory"][
                            elem
                          ]
                        }
                        approachVal={elem}
                        handler={setChoice}
                        group="Statutory"
                      />
                    </FormControl>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>
                        {elem}
                      </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography
                        className={classes.secondaryHeading}
                      ></Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <div className={classes.column}>
                      <Typography>{statutoryDict[elem]["GUIDANCE"]}</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography>Timing:</Typography>
                      <List dense>
                        {statutoryDict[elem]["TIMING"].map((val) => (
                          <ListItem
                            key={statutoryDict[elem]["TIMING"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                      <Typography>Necessary Approvals:</Typography>
                      <List dense>
                        {statutoryDict[elem]["APPROVAL AUTHORITY"].map(
                          (val) => (
                            <ListItem
                              key={statutoryDict[elem][
                                "APPROVAL AUTHORITY"
                              ].indexOf(val)}
                            >
                              <ListItemText secondary={val} />
                            </ListItem>
                          )
                        )}
                      </List>
                      <Typography>Relevant Sources:</Typography>
                      <List dense>
                        {statutoryDict[elem]["REFERENCE"].map((val) => (
                          <ListItem
                            key={statutoryDict[elem]["REFERENCE"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </AccordionDetails>
                  <Divider />
                  <AccordionActions>
                    <List dense>
                      {statutoryDict[elem]["LINKS"].map((val) => (
                        <ListItem
                          key={statutoryDict[elem]["LINKS"].indexOf(val)}
                        >
                          <ListItemText
                            secondary={
                              <a href={val} target="_blank>">
                                Resource for {elem}
                              </a>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionActions>
                </Accordion>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid item container xs={12}>
              {exceptionOptions.map((elem) => (
                <Accordion
                  key={exceptionOptions.indexOf(elem)}
                  style={{ width: "100%" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <FormControl style={{ marginRight: 16 }}>
                      <ApproachCheckbox
                        checkedVal={
                          props.currentContext.tailoringChoice["Exception"][
                            elem
                          ]
                        }
                        //nameVal={elem}
                        approachVal={elem}
                        handler={setChoice}
                        group="Exception"
                      />
                    </FormControl>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>
                        {elem}
                      </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography
                        className={classes.secondaryHeading}
                      ></Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <div className={classes.column}>
                      <Typography>{exceptionDict[elem]["GUIDANCE"]}</Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography>Timing:</Typography>
                      <List dense>
                        {exceptionDict[elem]["TIMING"].map((val) => (
                          <ListItem
                            key={exceptionDict[elem]["TIMING"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                      <Typography>Necessary Approvals:</Typography>
                      <List dense>
                        {exceptionDict[elem]["APPROVAL AUTHORITY"].map(
                          (val) => (
                            <ListItem
                              key={exceptionDict[elem][
                                "APPROVAL AUTHORITY"
                              ].indexOf(val)}
                            >
                              <ListItemText secondary={val} />
                            </ListItem>
                          )
                        )}
                      </List>
                      <Typography>Relevant Sources:</Typography>
                      <List dense>
                        {exceptionDict[elem]["REFERENCE"].map((val) => (
                          <ListItem
                            key={exceptionDict[elem]["REFERENCE"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </AccordionDetails>
                  <Divider />
                  <AccordionActions>
                    <List dense>
                      {exceptionDict[elem]["LINKS"].map((val) => (
                        <ListItem
                          key={exceptionDict[elem]["LINKS"].indexOf(val)}
                        >
                          <ListItemText
                            secondary={
                              <a href={val} target="_blank>">
                                Resource for {elem}
                              </a>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionActions>
                </Accordion>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid item container xs={12}>
              {regulatoryOptions.map((elem) => (
                <Accordion
                  key={regulatoryOptions.indexOf(elem)}
                  style={{ width: "100%" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <FormControl style={{ marginRight: 16 }}>
                      <ApproachCheckbox
                        checkedVal={
                          props.currentContext.tailoringChoice["Regulatory"][
                            elem
                          ]
                        }
                        //nameVal={elem}
                        approachVal={elem}
                        handler={setChoice}
                        group="Regulatory"
                      />
                    </FormControl>
                    <div className={classes.column}>
                      <Typography className={classes.heading}>
                        {elem}
                      </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography
                        className={classes.secondaryHeading}
                      ></Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <div className={classes.column}>
                      <Typography>
                        {regulatoryDict[elem]["GUIDANCE"]}
                      </Typography>
                    </div>
                    <div className={classes.column}>
                      <Typography>Timing:</Typography>
                      <List dense>
                        {regulatoryDict[elem]["TIMING"].map((val) => (
                          <ListItem
                            key={regulatoryDict[elem]["TIMING"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                      <Typography>Necessary Approvals:</Typography>
                      <List dense>
                        {regulatoryDict[elem]["APPROVAL AUTHORITY"].map(
                          (val) => (
                            <ListItem
                              key={regulatoryDict[elem][
                                "APPROVAL AUTHORITY"
                              ].indexOf(val)}
                            >
                              <ListItemText secondary={val} />
                            </ListItem>
                          )
                        )}
                      </List>
                      <Typography>Relevant Sources:</Typography>
                      <List dense>
                        {regulatoryDict[elem]["REFERENCE"].map((val) => (
                          <ListItem
                            key={regulatoryDict[elem]["REFERENCE"].indexOf(val)}
                          >
                            <ListItemText secondary={val} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </AccordionDetails>
                  <Divider />
                  <AccordionActions>
                    <List dense>
                      {regulatoryDict[elem]["LINKS"].map((val) => (
                        <ListItem
                          key={regulatoryDict[elem]["LINKS"].indexOf(val)}
                        >
                          <ListItemText
                            secondary={
                              <a href={val} target="_blank>">
                                Resource for {elem}
                              </a>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionActions>
                </Accordion>
              ))}
            </Grid>
          </TabPanel>
        </Paper>
        <Grid item container spacing={1}>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={prevPage}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={nextPage}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </Content>
    </>
  );
}
